// Truck Database for Construction, Demolition & Dirt Hauling
export const truckDatabase = [
  // === CONSTRUCTION DUMP TRUCKS ===
  {
    name: 'Single Axle Dump Truck',
    category: 'Construction Dump Trucks',
    capacityTons: 5,
    capacityCubicYards: 7,
    description: 'Small dump truck for light hauling jobs'
  },
  {
    name: 'Tandem Axle Dump Truck',
    category: 'Construction Dump Trucks',
    capacityTons: 10,
    capacityCubicYards: 12,
    description: 'Standard dump truck for construction and dirt hauling'
  },
  {
    name: 'Tri-Axle Dump Truck',
    category: 'Construction Dump Trucks',
    capacityTons: 15,
    capacityCubicYards: 18,
    description: 'Large dump truck for heavy loads of dirt and demo materials'
  },
  {
    name: 'Quad Axle Dump Truck',
    category: 'Construction Dump Trucks',
    capacityTons: 20,
    capacityCubicYards: 22,
    description: 'Extra large dump truck for maximum dirt hauling'
  },
  {
    name: 'Super Dump Truck',
    category: 'Construction Dump Trucks',
    capacityTons: 26,
    capacityCubicYards: 28,
    description: 'Maximum capacity dump truck for heavy construction'
  },
  {
    name: 'Transfer Dump Truck',
    category: 'Construction Dump Trucks',
    capacityTons: 25,
    capacityCubicYards: 26,
    description: 'Truck with separate trailer for bulk material hauling'
  },
  {
    name: 'Side Dump Truck',
    category: 'Construction Dump Trucks',
    capacityTons: 15,
    capacityCubicYards: 18,
    description: 'Truck that dumps to the side for tight spaces'
  },
  {
    name: 'Articulated Dump Truck (ADT)',
    category: 'Construction Dump Trucks',
    capacityTons: 30,
    capacityCubicYards: 32,
    description: 'Off-road articulated hauler for rough terrain'
  },
  
  // === SEMI TRAILERS (CONSTRUCTION/DIRT HAULING) ===
  {
    name: 'End Dump Semi Trailer',
    category: 'Semi Trailers',
    capacityTons: 23,
    capacityCubicYards: 25,
    description: 'Semi trailer with rear dump for dirt and aggregate'
  },
  {
    name: 'Belly Dump Semi Trailer',
    category: 'Semi Trailers',
    capacityTons: 24,
    capacityCubicYards: 26,
    description: 'Bottom discharge trailer for gravel and dirt'
  },
  {
    name: 'Side Dump Semi Trailer',
    category: 'Semi Trailers',
    capacityTons: 22,
    capacityCubicYards: 24,
    description: 'Side dumping semi for bulk materials'
  },
  {
    name: 'Flatbed Semi Truck (Construction)',
    category: 'Semi Trailers',
    capacityTons: 24,
    capacityCubicYards: null,
    description: 'Flatbed for hauling heavy construction materials (48-53 ft)'
  },
  {
    name: 'Lowboy Semi Trailer',
    category: 'Semi Trailers',
    capacityTons: 40,
    capacityCubicYards: null,
    description: 'Heavy equipment and demolition machinery hauler'
  },
  {
    name: 'Step Deck Semi Trailer',
    category: 'Semi Trailers',
    capacityTons: 24,
    capacityCubicYards: null,
    description: 'Two-level trailer for construction equipment and materials'
  },
  
  // === ROLL-OFF & SPECIALTY ===
  {
    name: 'Roll-Off Truck (10 Yard Dumpster)',
    category: 'Roll-Off Containers',
    capacityTons: 3,
    capacityCubicYards: 10,
    description: 'Small dumpster for light demo debris'
  },
  {
    name: 'Roll-Off Truck (20 Yard Dumpster)',
    category: 'Roll-Off Containers',
    capacityTons: 6,
    capacityCubicYards: 20,
    description: 'Standard dumpster for demolition materials'
  },
  {
    name: 'Roll-Off Truck (30 Yard Dumpster)',
    category: 'Roll-Off Containers',
    capacityTons: 9,
    capacityCubicYards: 30,
    description: 'Large dumpster for heavy demo work'
  },
  {
    name: 'Roll-Off Truck (40 Yard Dumpster)',
    category: 'Roll-Off Containers',
    capacityTons: 12,
    capacityCubicYards: 40,
    description: 'Extra large dumpster for major demolition'
  },
  {
    name: 'Concrete Mixer Truck',
    category: 'Specialty Construction',
    capacityTons: 10,
    capacityCubicYards: 10,
    description: 'Concrete delivery truck for construction sites'
  },
  {
    name: 'Grapple Truck',
    category: 'Specialty Construction',
    capacityTons: 8,
    capacityCubicYards: 15,
    description: 'Truck with hydraulic arm for loading demo debris'
  },
  {
    name: 'Vacuum Truck',
    category: 'Specialty Construction',
    capacityTons: 6,
    capacityCubicYards: 12,
    description: 'Suction truck for dirt, sludge, and loose materials'
  }
];